module.exports = __webpack_public_path__ + "media/images/tpximpact_logo-1adb570f.png";